import * as React from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Box } from '@mui/system';
import { getActivatedPolicyByDate } from 'app/store/features/privacyPersistedSlice';
import { ColorsV2 } from 'app/constants/color';
import { Buttons } from 'app/constants/sizing';

export default function BasicTable() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const allPolicies = useSelector(state => state.privacy.allPolicies);
  const withoutTemplate = useSelector(state => state.privacyPersisted.WithoutTemplate);
  const parseAndFormatDate = dateString => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    const formattedDate = new Date(dateString).toLocaleDateString(undefined, options);
    return formattedDate;
  };

  const handleView = privacyValue => {
    dispatch(getActivatedPolicyByDate(privacyValue)).then(() => {
      if (withoutTemplate) navigate('/board/template', { state: { action: 'VIEW' } });
    });
  };

  return (
    <TableContainer
      component={Paper}
      sx={{
        backgroundColor: ColorsV2.primary,
        border: `2px solid ${ColorsV2.outline}`,
        borderRadius: '0px',
        width: '30%',
      }}
      elevation={0}
    >
      <Table aria-label='simple table'>
        <TableHead sx={{ backgroundColor: ColorsV2.secondary }}>
          <TableRow>
            <TableCell
              sx={{
                borderRight: `2px solid ${ColorsV2.outline}`,
                color: ColorsV2.white,
                borderBottom: 0,
              }}
            >
              Activation date
            </TableCell>

            <TableCell sx={{ color: ColorsV2.white, borderBottom: 0 }}> </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {allPolicies?.activationDates?.map(activationDate => {
            return (
              <TableRow
                key={activationDate}
                sx={{ '& td': { borderBottom: "solid 2px " + ColorsV2.outline, padding: '4px 16px 4px 16px' } }}
              >
                <TableCell
                  sx={{
                    color: ColorsV2.textInfo,
                    borderRight: `2px solid ${ColorsV2.outline}`,
                  }}
                >
                  {parseAndFormatDate(activationDate)}
                </TableCell>

                <TableCell align='center'>
                  <Box
                    sx={{ ...Buttons.baseStyle.textButton, color: ColorsV2.white, textDecoration: 'underline', cursor: 'pointer', '&:hover': {borderBottomColor: 'transparent'}}}
                    onClick={() => {
                      handleView(`${allPolicies?.policyType}/${activationDate}`);
                    }}
                  >
                    view definition
                  </Box>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
